module.exports = __webpack_public_path__ + "media/greenplay.8b07ad2c.mp3";